import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"
import Lock from "./Lock.js"
import Unlock from "./Unlock.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"

import dateFunctions from '../../functions/dateFunctions';

class Usuarios extends Component {
    constructor() {
        super();
        this.state = {
            sort: [{
                id: 'fullname',
                desc: false
            }],
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "fullname",
                    accessor: d => d.fullname,
                    show: true,
                    width: 300,
                },
                {
                    Header: "Usuario",
                    id: "username",
                    accessor: d => d.username,
                    show: true,
                    width: 200,
                },
                {
                    Header: "Email",
                    id: "perfil__persona__email",
                    accessor: "perfil__persona__email",
                    filterable: true,
                    show: true,
                },
                {
                    Header: "Departamento",
                    id: "perfil__persona__departamento__nombre",
                    accessor: "perfil__persona__departamento__nombre",
                    filterable: true,
                    width: 200,
                    show: true,
                },
                {
                    Header: "Fecha Registro",
                    id: "perfil__fechaModificado",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.perfil__fechaModificado),
                    filterable: true,
                    width: 200,
                    show: true,
                },
                {
                    Header: "Activo",
                    id: "is_active",
                    accessor: d => (d.is_active ? "SI" : "NO"),
                    filterable: true,
                    width: 100,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'usuarios_new',
                        component: Create,
                    },
                    {
                        detail: true,
                        permission: 'usuarios_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'usuarios_edit',
                        component: Edit,
                    },
                    {
                        edit: true,
                        permission: 'usuarios_habilitar',
                        component: Lock,
                    },
                    {
                        edit: true,
                        permission: 'usuarios_deshabilitar',
                        component: Unlock,
                    },
                    {
                        edit: true,
                        permission: 'usuarios_delete',
                        component: Delete,
                    },
                ]}
                outerSort={this.state.sort}
                apiUrl={api.usuarios.usuarios.list}
                columns={this.state.columns}
                exportUrl={api.usuarios.usuarios.export}
                title={"Usuarios"}
            />
        );
    }
}

export default Usuarios;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Usuarios.js